<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Multiselect from 'vue-multiselect';
import { REGIONES, getComunas, getProvincia } from '@/utils/chile-comunas';

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Crear Colegio",
            items: [
                { text: "Configuración", href: "/" },
                { text: "Colegios", href: "/web/configuracion/colegios" },
                { text: "Crear Colegio", active: true }
            ],
            isLoading: false,
            regiones: REGIONES,
            regionSeleccionada: 'Metropolitana de Santiago',
            comunaSeleccionada: null,
            opciones: ['Sí', 'No'],
            phoneerror1: '',
            phoneerror2: '',
            phoneerror3: '',
            emailError1: '',
            emailError2: '',
            form: {
                rbd: '',
                nombre: '',
                tipo_educacion: '',
                nivel_socioeconomico: '',
                colegio_visitado: null,
                direccion: '',
                comuna: '',
                provincia: '',
                region: 'Metropolitana de Santiago',
                telefono_colegio: '',
                nombre_director: '',
                correo_colegio: '',
                telefono_director: '',
                nombre_orientador: '',
                correo_colegio_2: '',
                telefono_orientador: '',
            }
        };
    },
    computed: {
        isEmailValid1() {
            if (!this.form.correo_colegio) return true;
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.correo_colegio);
        },
        isEmailValid2() {
            if (!this.form.correo_colegio_2) return true;
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.correo_colegio_2);
        },
        comunasFiltradas() {
            if (!this.regionSeleccionada) return [];
            return getComunas(this.regionSeleccionada).map(c => c.comuna).sort();
        }
    },
    watch: {
        regionSeleccionada(val) {
            this.form.region = val || '';
            this.comunaSeleccionada = null;
            this.form.comuna = '';
            this.form.provincia = '';
        },
        comunaSeleccionada(val) {
            this.form.comuna = val || '';
            this.form.provincia = val ? getProvincia(this.regionSeleccionada, val) : '';
        }
    },
    methods: {
        validateEmail1() {
            this.emailError1 = !this.isEmailValid1 ? 'El correo electrónico no es válido.' : '';
        },
        validateEmail2() {
            this.emailError2 = !this.isEmailValid2 ? 'El correo electrónico no es válido.' : '';
        },
        formatPhoneNumber1() {
            let digits = this.form.telefono_director.replace(/\D/g, '');
            if (!digits.startsWith('56')) digits = '56' + digits;
            if (digits.length > 11) digits = digits.slice(0, 11);
            this.form.telefono_director = '+' + digits;
        },
        validatePhoneNumber1() {
            this.phoneerror1 = this.form.telefono_director && this.form.telefono_director.length !== 12
                ? 'El número debe ser +56 seguido de 9 dígitos.' : '';
        },
        formatPhoneNumber2() {
            let digits = this.form.telefono_colegio.replace(/\D/g, '');
            if (!digits.startsWith('56')) digits = '56' + digits;
            if (digits.length > 11) digits = digits.slice(0, 11);
            this.form.telefono_colegio = '+' + digits;
        },
        validatePhoneNumber2() {
            this.phoneerror2 = this.form.telefono_colegio && this.form.telefono_colegio.length !== 12
                ? 'El número debe ser +56 seguido de 9 dígitos.' : '';
        },
        formatPhoneNumber3() {
            let digits = this.form.telefono_orientador.replace(/\D/g, '');
            if (!digits.startsWith('56')) digits = '56' + digits;
            if (digits.length > 11) digits = digits.slice(0, 11);
            this.form.telefono_orientador = '+' + digits;
        },
        validatePhoneNumber3() {
            this.phoneerror3 = this.form.telefono_orientador && this.form.telefono_orientador.length !== 12
                ? 'El número debe ser +56 seguido de 9 dígitos.' : '';
        },
        restrictToNumbers(event) {
            const allowed = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
            if (!allowed.includes(event.key) && !/^\d$/.test(event.key)) event.preventDefault();
        },
        restrictInput_withspace(event) {
            const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
            if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(event.key) && !allowed.includes(event.key)) event.preventDefault();
        },
        msgval(campo) {
            Swal.fire({ icon: 'warning', title: `El campo "${campo}" es requerido`, showConfirmButton: false, timer: 3000 });
        },
        validar() {
            if (!this.form.rbd) { this.msgval('RBD'); return false; }
            if (!this.form.nombre) { this.msgval('Nombre del Colegio'); return false; }
            if (!this.form.direccion) { this.msgval('Dirección'); return false; }
            if (!this.form.nombre_director) { this.msgval('Nombre Director'); return false; }
            if (!this.form.colegio_visitado) { this.msgval('¿Colegio Visitado?'); return false; }
            if (!this.isEmailValid1) { this.msgval('Correo Director (formato inválido)'); return false; }
            if (!this.isEmailValid2) { this.msgval('Correo Orientador (formato inválido)'); return false; }
            return true;
        },
        async guardar() {
            if (!this.validar()) return;
            this.isLoading = true;
            try {
                const res = await axios.post('/api/crear_colegio', { ...this.form });
                this.isLoading = false;
                if (res.data.estado) {
                    await Swal.fire({ icon: 'success', title: '¡Colegio creado!', text: res.data.mensaje, showConfirmButton: false, timer: 2500 });
                    localStorage.setItem('rbd_colegio', this.form.rbd);
                    window.location.href = '/web/configuracion/colegios';
                } else {
                    Swal.fire({ icon: res.data.color || 'error', title: res.data.mensaje, showConfirmButton: false, timer: 4000 });
                }
            } catch (e) {
                this.isLoading = false;
                Swal.fire({ icon: 'error', title: 'Error al crear el colegio', showConfirmButton: false, timer: 3000 });
            }
        },
        cancelar() {
            window.location.href = '/web/configuracion/colegios';
        }
    },
    mounted() {
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loading-message v-if="isLoading" />

        <div class="row" v-if="!isLoading">
            <div class="col-12">
                <div class="card">
                    <!-- Header UGM -->
                    <div class="card-header py-3 d-flex align-items-center justify-content-between"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">
                                <i class="bx bx-buildings mr-2"></i>Nuevo Colegio
                            </h5>
                            <small class="text-white" style="opacity:.8;">Completa los datos para registrar un nuevo colegio</small>
                        </div>
                        <div class="d-flex" style="gap:8px;">
                            <button @click="cancelar" class="btn-ugm-white">
                                <i class="fas fa-times mr-1"></i> Cancelar
                            </button>
                            <button @click="guardar" class="btn-ugm-gold">
                                <i class="fas fa-save mr-1"></i> Guardar Colegio
                            </button>
                        </div>
                    </div>

                    <div class="card-body pt-4">

                        <!-- ── SECCIÓN: Información General ── -->
                        <div class="d-flex align-items-center mb-3">
                            <div style="width:4px;height:20px;background:#252C5F;border-radius:2px;margin-right:8px;"></div>
                            <span class="font-weight-bold" style="color:#252C5F;">Información General</span>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>RBD <span class="text-danger">*</span></label>
                                    <input type="text" v-model="form.rbd" class="form-control" placeholder="Ej: 9321">
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group">
                                    <label>Nombre del Colegio <span class="text-danger">*</span></label>
                                    <input type="text" v-model="form.nombre" class="form-control" placeholder="Ej: Colegio San Pedro">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>¿Colegio Visitado? <span class="text-danger">*</span></label>
                                    <multiselect v-model="form.colegio_visitado" :options="opciones"
                                        placeholder="Seleccionar" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Remover">
                                        <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Tipo Educación</label>
                                    <input type="text" v-model="form.tipo_educacion" class="form-control" placeholder="Ej: Particular Subvencionado">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Nivel Socioeconómico</label>
                                    <input type="text" v-model="form.nivel_socioeconomico" class="form-control" placeholder="Ej: Medio">
                                </div>
                            </div>
                        </div>

                        <!-- ── SECCIÓN: Ubicación ── -->
                        <div class="d-flex align-items-center mt-2 mb-3">
                            <div style="width:4px;height:20px;background:#61B7E4;border-radius:2px;margin-right:8px;"></div>
                            <span class="font-weight-bold" style="color:#252C5F;">Ubicación</span>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Dirección <span class="text-danger">*</span></label>
                                    <input type="text" v-model="form.direccion" class="form-control" placeholder="Ej: Av. Principal 123">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Región</label>
                                    <multiselect v-model="regionSeleccionada" :options="regiones"
                                        placeholder="Seleccionar región" selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Limpiar">
                                        <template v-slot:noOptions><span class="text-muted">Sin opciones</span></template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Comuna</label>
                                    <multiselect v-model="comunaSeleccionada" :options="comunasFiltradas"
                                        :placeholder="regionSeleccionada ? 'Seleccionar comuna' : 'Primero elige una región'"
                                        selectLabel="Seleccionar" selectedLabel="✓" deselectLabel="Limpiar"
                                        :style="!regionSeleccionada ? 'pointer-events:none;opacity:.55;' : ''">
                                        <template v-slot:noOptions><span class="text-muted">Sin comunas</span></template>
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Provincia</label>
                                    <input type="text" :value="form.provincia" class="form-control" readonly
                                        placeholder="Se completa al elegir la comuna"
                                        style="background:#f8f9fa;cursor:default;">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Teléfono Colegio</label>
                                    <input type="text" v-model="form.telefono_colegio" class="form-control"
                                        placeholder="+569XXXXXXXX" maxlength="12"
                                        @input="formatPhoneNumber2" @blur="validatePhoneNumber2" @keydown="restrictToNumbers">
                                    <small v-if="phoneerror2" class="text-danger">{{ phoneerror2 }}</small>
                                </div>
                            </div>
                        </div>

                        <!-- ── SECCIÓN: Director ── -->
                        <div class="d-flex align-items-center mt-2 mb-3">
                            <div style="width:4px;height:20px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                            <span class="font-weight-bold" style="color:#252C5F;">Datos del Director</span>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Nombre Director <span class="text-danger">*</span></label>
                                    <input type="text" v-model="form.nombre_director" class="form-control"
                                        placeholder="Nombre completo" @keydown="restrictInput_withspace">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Correo Director</label>
                                    <input type="text" v-model="form.correo_colegio" class="form-control"
                                        placeholder="director@colegio.cl" @blur="validateEmail1">
                                    <small v-if="emailError1" class="text-danger">{{ emailError1 }}</small>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Teléfono Director</label>
                                    <input type="text" v-model="form.telefono_director" class="form-control"
                                        placeholder="+569XXXXXXXX" maxlength="12"
                                        @input="formatPhoneNumber1" @blur="validatePhoneNumber1" @keydown="restrictToNumbers">
                                    <small v-if="phoneerror1" class="text-danger">{{ phoneerror1 }}</small>
                                </div>
                            </div>
                        </div>

                        <!-- ── SECCIÓN: Orientador ── -->
                        <div class="d-flex align-items-center mt-2 mb-3">
                            <div style="width:4px;height:20px;background:#252C5F;border-radius:2px;margin-right:8px;opacity:.4;"></div>
                            <span class="font-weight-bold" style="color:#252C5F;">Datos del Orientador</span>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Nombre Orientador</label>
                                    <input type="text" v-model="form.nombre_orientador" class="form-control"
                                        placeholder="Nombre completo" @keydown="restrictInput_withspace">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Correo Orientador</label>
                                    <input type="email" v-model="form.correo_colegio_2" class="form-control"
                                        placeholder="orientador@colegio.cl" @blur="validateEmail2">
                                    <small v-if="emailError2" class="text-danger">{{ emailError2 }}</small>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Teléfono Orientador</label>
                                    <input type="text" v-model="form.telefono_orientador" class="form-control"
                                        placeholder="+569XXXXXXXX" maxlength="12"
                                        @input="formatPhoneNumber3" @blur="validatePhoneNumber3" @keydown="restrictToNumbers">
                                    <small v-if="phoneerror3" class="text-danger">{{ phoneerror3 }}</small>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.btn-ugm-white {
    background: #fff !important;
    color: #252C5F !important;
    border: 1px solid #fff !important;
    border-radius: 6px;
    padding: 5px 14px;
    font-size: .8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-white:hover { opacity: .85; }

.btn-ugm-gold {
    background: #CB9700 !important;
    color: #fff !important;
    border: 1px solid #CB9700 !important;
    border-radius: 6px;
    padding: 5px 14px;
    font-size: .8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-gold:hover { opacity: .88; }
</style>
